import React from "react";
import a23logo from "../assets/a23_avatar_logo.png";
import close from "../assets/close.png";
import { connect } from "react-redux";
import { toggleModalAction, pokerAmountToA23Transfer, toggleAlertAction } from '../redux/actions/userAction'
import Loading from "./Loading"
import CommonAlert from "./PKCommonAlert"
import { POKER_TDS_INFO } from "../Strings"
import { Link } from "react-router-dom"
import VerificationAlert from "./VerificationAlert";
import Tooltip from '../CustomTooltip.js';

class PokertoA23Transfer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: window.sessionStorage["token"],
      isTransferBtnClick: true,
      message: "",
      btntext: ""
    };
  }

  PokerBalanceToA23BalanceTransfer = async () => {
    this.setState({ isTransferBtnClick: false })
    if (this.props.tdsAmount > 0) {
      // if (this.getUserKYCStatus(this.props.kycStatus)) {
        console.log("Poker Button click");
        await this.props.pokerAmountToA23Transfer(this.state.token, "1");

        const { pokerToA23TransferRes } = this.props.userState;
        console.log("Poker Transfer", pokerToA23TransferRes);
        if (pokerToA23TransferRes.error) {
          console.log("Poker Transfer fail:::", pokerToA23TransferRes.error);
          if (pokerToA23TransferRes.message) {
            this.props.toggleAlertAction(true, pokerToA23TransferRes.message, 4000, "bg-green");
          } else {
            this.props.toggleAlertAction(true, pokerToA23TransferRes.error, 4000, "bg-red");
          }
          this.props.handleUserTDSInfoRes();
          this.props.toggleModalAction(false);
        } else {
          console.log("Poker Transfer Success::", pokerToA23TransferRes);
          this.props.toggleModalAction(false);
          this.setState({ isTransferBtnClick: true })
          if (pokerToA23TransferRes.status) {
            this.props.toggleAlertAction(true, pokerToA23TransferRes.message, 4000, "bg-green");
            this.props.handleUserTDSInfoRes();
          } else {
            this.props.toggleAlertAction(true, pokerToA23TransferRes.message, 4000, "bg-red");
            this.props.handleUserTDSInfoRes();
          }
          // this.props.toggleAlertAction(true, pokerToA23TransferRes.message);

          this.props.toggleModalAction(false);
        }
      // }
    } else {
      await this.props.pokerAmountToA23Transfer(this.state.token, "1");
      this.setState({ isTransferBtnClick: false })
      const { pokerToA23TransferRes } = this.props.userState;
      console.log("Poker Transfer", pokerToA23TransferRes);
      if (pokerToA23TransferRes.error) {
        console.log("Poker Transfer fail:::", pokerToA23TransferRes.error);
        if (pokerToA23TransferRes.status) {
          this.props.toggleAlertAction(true, pokerToA23TransferRes.message, 4000, "bg-green");
          this.props.handleUserTDSInfoRes();
        } else {
          this.props.toggleAlertAction(true, pokerToA23TransferRes.message, 4000, "bg-red");
          this.props.handleUserTDSInfoRes();
        }
      } else {
        console.log("Poker Transfer Success::", pokerToA23TransferRes);
        this.props.toggleModalAction(false);
        //this.setState({isTransferBtnClick:true})
        if (pokerToA23TransferRes.status) {
          this.props.toggleAlertAction(true, pokerToA23TransferRes.message, 4000, "bg-green");
          this.props.handleUserTDSInfoRes();
        } else {
          this.props.toggleAlertAction(true, pokerToA23TransferRes.message, 4000, "bg-red");
          this.props.handleUserTDSInfoRes();
        }
        // this.props.toggleAlertAction(true, pokerToA23TransferRes.message);
        this.props.toggleModalAction(false);
      }
    }
  }

  //Check User KYC Status
  getUserKYCStatus = (kysStatus) => {
    console.log("PK KYC Status:::", kysStatus);
    switch (kysStatus) {
      //[TS_STRINGS.KEY_TS_ALL, TS_STRINGS.KEY_TS_ADDCASH, TS_STRINGS.KEY_TS_REDEEM, TS_STRINGS.KEY_TS_RUMMY, TS_STRINGS.KEY_TS_FANTACY, TS_STRINGS.KEY_TS_POKER, TS_STRINGS.KEY_TS_CARROM, TS_STRINGS.KEY_TS_POOL, TS_STRINGS.KEY_TS_BONUS, TS_STRINGS.KEY_TS_REFUND, TS_STRINGS.KEY_TS_REDEEM_CANCEL ],
      // if(kysStatus == POKER_TDS_INFO.PK_KYC_NOT_SUBMITTED){
      //   console.log("KYC Not Submitted")
      //   return false 
      // }
      case POKER_TDS_INFO.PK_KYC_APPROVED:
        return true
      case POKER_TDS_INFO.PK_KYC_PROCESSING:
        this.props.toggleModalAction(
          true,
          <CommonAlert
            header={POKER_TDS_INFO.POKER_TDS_INFO_HEADER}
            body={POKER_TDS_INFO.PK_KYC_PROCESSING_TEXT_MSG}
            btntext={POKER_TDS_INFO.PK_KYC_OKAY}
          ></CommonAlert>
        );
        return false
      case POKER_TDS_INFO.PK_KYC_REJECTED:
        this.props.toggleModalAction(
          true,
          <CommonAlert
            header={POKER_TDS_INFO.POKER_TDS_PAN_VERIFICATION_HEADER}
            body={POKER_TDS_INFO.PK_KYC_REJECTED_TEXT_MSG}
            btntext={POKER_TDS_INFO.PK_KYC_REVERIFY}
          ></CommonAlert>
        );
        return false
      case POKER_TDS_INFO.PK_KYC_NOT_SUBMITTED:
        console.log("KYC Not Submitted")
        this.props.toggleModalAction(
          true,
          <CommonAlert
            header={POKER_TDS_INFO.POKER_TDS_PAN_VERIFICATION_HEADER}
            body={POKER_TDS_INFO.PK_KYC_NOT_SUBMITTED_TEXT_MSG}
            btntext={POKER_TDS_INFO.PK_KYC_VERIFY_PAN}
          ></CommonAlert>
        );
        return false
      //PK_KYC_BLOCKED
      case POKER_TDS_INFO.PK_KYC_UNVERIFIED:
        this.props.toggleModalAction(
          true,
          <CommonAlert
            header={POKER_TDS_INFO.POKER_TDS_PAN_VERIFICATION_HEADER}
            body={POKER_TDS_INFO.PK_KYC_REJECTED_TEXT_MSG}
            btntext={POKER_TDS_INFO.PK_KYC_VERIFY_PAN}
          ></CommonAlert>
        );
        return false
      case POKER_TDS_INFO.PK_KYC_BLOCKED:
        this.props.toggleModalAction(
          true,
          <CommonAlert
            header={POKER_TDS_INFO.POKER_TDS_INFO_HEADER}
            body={POKER_TDS_INFO.PK_KYC_BLOCKED_TEXT_MSG}
            btntext={POKER_TDS_INFO.PK_KYC_OKAY}
          ></CommonAlert>
        );
        return false
      default:
        return false
    }
  }

  //Checking For TDS APPLICABLE OR NOT
  //not using since TDS changes @yashwanth
  checkTransferAmountTDSEligibilty = (tdsAmount) => {
    if (tdsAmount > 0) {
      return true;
    } else {
      return false;
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }
  async componentWillMount() {
    //for Dynamic Token
    this.setState({ token: window.sessionStorage["token"] })
    this.setState({ channel: window.sessionStorage["channel"] })

  }

  async componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.setState({ token: window.sessionStorage["token"] })
    this.setState({ channel: window.sessionStorage["channel"] })
  }

  render() {
    return (
      <div>
        <div class="relative absolute--fill flex justify-center items-center center left-1 right-1 white w6 ">
          <img
            class="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  z-9999 "
            src={a23logo} alt="no"
          ></img>
          <div
            className="center ph2 br3 ba pa1 b--black-10 flex flex-column"
            style={{ backgroundColor: "#fffdea", color: "#032146", bordercolor: "#EABF6979", paddingTop: "1rem", borderRadius: "10px" }}
          >
            <div className="db pt0 f6 mt1 ">
              {console.log("this.state.isTransferBtnClick: ", this.state.isTransferBtnClick)}
              {this.state.isTransferBtnClick ? (<img
                class="absolute top-0 right-0 pa2"
                style={{ width: "23px", height: "23px" }}
                src={close}
                alt="no "
                onClick={() => this.props.toggleModalAction(false)}
              ></img>) : (<img
                class="absolute top-0 right-0 pa2"
                style={{ width: "23px", height: "23px" }}
                src={close}
                alt="no "
              ></img>)}

              <div className="w-100 db f6 tc">
                <h4 className="mt0 fw4 f4 text-bold mt3" style={{ color: "#032146" }} >{POKER_TDS_INFO.POKER_TDS_INFO_HEADER} </h4>

                {/* Cash transfer confirmation alert */}
                <div className="flex flex-column">
                  <span className="f5 text">{POKER_TDS_INFO.POKER_CASH_TRANSFER_CONFIRMATION_TEXT}</span>
                  {/* <p className="center text tc">
                    <span className="mv0 text f6 b">{POKER_TDS_INFO.POKER_CASH_TRANSFER_NOTE_TEXT} </span>
                  </p> */}
                </div>

                {/* {this.checkTransferAmountTDSEligibilty(this.props.tdsAmount) ?
                    (<div>
                      <table>
                        <tbody> */}
                {/* below one line should remain commented @yashwanth, as it was already commented before TDS changes */}
                {/* <tr className="pv2 ph3 fw5 f5 text tl"  style={{color:"#032146"}}> {POKER_TDS_INFO.POKER_TDS_ONTRANSFER}</tr> */}
                {/* <tr><td class="pv2 ph3 tl f5 text" style={{ color: "#032146" }}>{POKER_TDS_INFO.POKER_TDS_ONTRANSFER}</td><td class="pv2 ph3 f5 text"></td><td class="pv2 ph3 f5 text"></td></tr>
                          <tr><td class="pv2 ph3 tl f5 text" style={{ color: "#032146" }}>{POKER_TDS_INFO.POKER_CREDITED_TO_A23_BALANCE}</td><td class="pv2 ph3 f5 text">:</td><td class="pv2 ph3 f5 text">{this.props.amount}</td></tr>
                          <tr><td class="pv2 ph3 tl f5 text" style={{ color: "#032146" }}>{POKER_TDS_INFO.POKER_TDS_DEDUCTION}</td><td class="pv2 ph3 f5 text">:</td><td class="pv2 ph3 f5 text">{this.props.tdsAmount}</td><td> <div style={{ marginLeft: "9px" }}
                          >
                            <Tooltip
                              tooltipBox="tooltip-box"
                              tooltipArrow="tooltip-arrow"
                              from="wallet"
                              text={POKER_TDS_INFO.POKER_TDS_INFO_TOOLTIP_MESSAGE1}
                              text2={POKER_TDS_INFO.POKER_TDS_INFO_TOOLTIP_MESSAGE2}
                            >
                              <div className="f10 flex justify-center items-center br-100 " style={{ width: "1rem", height: "1rem", padding: "0.5rem", backgroundColor: "#58b6c6", color: "#F8F8F8" }}>i
                              </div>
                            </Tooltip>
                          </div></td></tr>
                        </tbody></table>
                    </div>) :
                    (<div className="flex flex-column"><span className="f5 text">{POKER_TDS_INFO.POKER_CASH_TRANSFER_TEXT}</span><p className="center text tc"><span className="mv0 text f5">{POKER_TDS_INFO.POKER_TDS_TRANSFER} </span><span>:</span><span className="mv0 f5 text"> {this.props.amount}</span></p></div>)} */}
                
                {/* Transfer button */}
                {this.state.isTransferBtnClick ? (<div className="mt2 mb2"><button className='ph4 pv2 tc center bw0 f5 fw4 dib br2 btn-green btn-green-login white'
                  style={{ height: "auto" }} type='submit' onClick={() => this.PokerBalanceToA23BalanceTransfer()}>{POKER_TDS_INFO.POKER_TDS_TRANSFER}</button></div>) : (<div className="mb2"><button className='ph4 pv2 tc center bw0 f5 fw4 dib br2 btn btn-grey white o-70'
                    style={{ height: "auto" }} type='submit'>{POKER_TDS_INFO.POKER_TDS_TRANSFER}</button></div>)}
              </div>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>

    );
  }
}
const mapStateToProps = state => ({
  userState: state.userState
});

export default connect(
  mapStateToProps,
  { toggleModalAction, pokerAmountToA23Transfer, toggleAlertAction }
)(PokertoA23Transfer);
